<template>
  <div class="news_zx news_zxinfo">
    <!-- 新闻资讯详情 -->
    <!-- nav -->
    <index-nav></index-nav>
    <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/news_banner.jpg" alt />
      </div>
      <div class="infoCon inner">
        <!-- 面包屑导航 -->
        <div class="mbnav">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <img class="homeIcon" src="/statics/images/info/home.png" alt />
              首页
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news_zx' }">新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{newsInfo.detail.cate.name}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <h3>{{newsInfo.detail.title}}</h3>
          <span>{{newsInfo.detail.created_at}}</span>
        </div>
        <!-- 新闻内容 -->
        <div class="newscom" v-html="content"></div>
        <!-- 上一篇 -->
        <div class="pian">
          <div class="shang" @click="toInfo(newsInfo.next.id)">
            上一篇：
            <span>{{newsInfo.next.title}}</span>
          </div>
          <div class="xia" @click="toInfo(newsInfo.pre.id)">
            下一篇：
            <span>{{newsInfo.pre.title}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      newsId: "", //新闻id
      newsInfo: {
        detail: {
          cate: {}
        },
        next: {},
        pre: {}
      }, //新闻详情
      content: "" //富文本
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    this.newsId = this.$route.query.id;
    this.getNewsInfo(); //新闻详情
  },
  methods: {
    getNewsInfo() {
      var that = this;
      var ps = {
        id: that.newsId
      };
      that.$api.index.newsDetail(ps).then(function(res) {
        if (res.code == 200) {
          that.newsInfo = res.result;
          that.content = res.result.detail.content.replace(
            /\<img src\=\"\upload/g,
            '<img class="fupic" src="' + that.$url + "/upload"
          );
          // console.log(that.content);
        }
      });
    },
    toInfo(id) {
      if (id != 0) {
        this.$router.push({
          path: "/news_zxinfo",
          query: {
            id: id
          }
        });
      }
    }
  },
  // watch: {
  //   $route(to, from) {
  //     location.reload();//刷新页面
  //   }
  // },
  mounted: function() {}
};
</script>

<style>
</style>